import React from 'react';
import { useApp } from '../context/AppContext';
import { ScanLine, User as UserIcon, Clock, BookOpen, User } from 'lucide-react';

const BottomNav = () => {
  const { activeTab, setActiveTab, setCurrentScreen } = useApp();

  const tabs = [
    { id: 'scan', label: 'Scan', icon: ScanLine },
    { id: 'history', label: 'History', icon: Clock },
    { id: 'encyclopedia', label: 'Encyclopedia', icon: BookOpen },
    { id: 'avatar', label: 'Avatar', icon: UserIcon },
    { id: 'profile', label: 'Profile', icon: User }
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    setCurrentScreen(tabId);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-black/10 z-50">
      <div className="max-w-md mx-auto flex justify-around items-center h-16 py-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`flex flex-col items-center justify-center w-full py-2 transition-all duration-300 relative group`}
              data-testid={`nav-${tab.id}`}
            >
              {isActive && (
                <span className="absolute -top-0.5 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-black rounded-full transition-all duration-300" />
              )}
              <div className={`p-1.5 rounded-xl transition-all duration-300
                ${isActive ? 'bg-black/10' : 'group-hover:bg-black/5'}`}>
                <Icon 
                  size={18} 
                  strokeWidth={isActive ? 2 : 1.5}
                  className={`transition-all duration-300 
                    ${isActive ? 'text-black' : 'text-black/55 group-hover:text-black/72'}`}
                />
              </div>
              <span className={`text-[9px] mt-0.5 tracking-wider uppercase transition-all duration-300
                ${isActive ? 'text-black font-bold' : 'text-black/55 font-semibold'}`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;